import React from "react";
import { Row, Col } from "react-bootstrap";
import { IoCaretDown, IoCaretUp } from "react-icons/io5";

import { SectionTitle, StatTitle } from "./StyledComponents";
import SingleMeasure from "./SingleMeasure";
import { withTranslation } from "react-i18next";
import styled from "styled-components";
import { Collapse } from "react-bootstrap";

import {
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
} from "recharts";

const COLORS = {
  background: "#ffffff",
  grid: "#f1f5f9",
  gradient: "#38bdf8",
  legends: "#64748b",
  stroke: "#0284c7",
};

const ChartTitle = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: ${COLORS.legends};
  letter-spacing: 0.5px;
  margin-bottom: 12px;
  display: block;
`;

const GaugeCard = styled.div`
  background: #ffffff;
  border-radius: 12px;
  padding: 20px;
  box-shadow:
    0 1px 3px rgba(0, 0, 0, 0.04),
    0 1px 2px rgba(0, 0, 0, 0.02);
  border: 1px solid #f1f5f9;
  margin-bottom: 20px;
`;

const GaugeContainer = styled.div`
  position: relative;
  width: 100%;
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: flex-end;
`;

const GaugeCenterTotal = styled.div`
  position: absolute;
  bottom: 40px;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
`;

const TotalValue = styled.span`
  font-size: 30px;
  font-weight: 700;
  color: #0f172a;
  line-height: 1;
`;

const GraphRow = styled(Row)`
  display: flex;
  justify-content: flex-end;
`;

const RenderChartButton = (props) => {
  const { chartOpen, flipState } = props;
  const ChartButton = chartOpen ? IoCaretUp : IoCaretDown;
  return (
    <ChartButton
      style={{ cursor: "pointer", marginLeft: "1em" }}
      onClick={flipState}
    />
  );
};

const PotentialBreakdownGauge = (props) => {
  const { t, data, opened } = props;

  const filteredData = data
    .filter(({ value }) => !!value)
    .map((datum) => {
      const translatedData = { ...datum };
      translatedData.name = t(datum.name);
      return translatedData;
    });
  const validData = !!filteredData.length;

  return (
    <Collapse in={opened}>
      {!validData ? (
        <div>
          <ChartTitle>{t("No Data")}</ChartTitle>
        </div>
      ) : (
        <GaugeCard>
          <div>
            <ChartTitle>{t("Potential breakdown")}</ChartTitle>
          </div>
          <GaugeContainer>
            <ResponsiveContainer width="100%" height={220}>
              <PieChart>
                <Pie
                  data={filteredData}
                  cx="50%"
                  cy="90%"
                  startAngle={180}
                  endAngle={0}
                  innerRadius={80}
                  outerRadius={110}
                  paddingAngle={4}
                  dataKey="value"
                  legendType="circle"
                  label
                >
                  <Legend />
                  {filteredData.map((entry, index) => (
                    <Cell
                      key={`cell-${index}`}
                      fill={entry.fill}
                      stroke="none"
                    />
                  ))}
                </Pie>
                <Tooltip
                  formatter={(value, name) => [`${value}%`, t(name)]}
                  contentStyle={{
                    backgroundColor: "#ffffff",
                    borderRadius: "8px",
                    border: "1px solid #e2e8f0",
                  }}
                />
              </PieChart>
            </ResponsiveContainer>

            {/* Center Total Label */}
            <GaugeCenterTotal>
              <TotalValue>{t("optimized percent")}</TotalValue>
            </GaugeCenterTotal>
          </GaugeContainer>
        </GaugeCard>
      )}
    </Collapse>
  );
};

function ExtraPotentialRowRevenue(props) {
  const {
    annualRaw,
    dailyRaw,
    t,
    potentialChartOpen,
    flipPotentialGraphShow,
    lossPercentages,
    currencyCode: units,
  } = props;

  const dailyValue = Math.round(parseInt(dailyRaw, 10));
  const annualValue = Math.round(parseInt(annualRaw, 10));
  const daily = Number.isNaN(dailyValue) ? "" : dailyValue;
  const annual = Number.isNaN(annualValue) ? "" : annualValue;

  return (
    <>
      <Row>
        <Col xs={12} sm={4}>
          <SectionTitle>{t("Potential extra revenue")}</SectionTitle>
        </Col>
        <Col xs={12} sm={4}>
          <StatTitle>{t("Annual")}</StatTitle>
          <SingleMeasure
            value={`${annual}`}
            units={units}
            alwaysBlackMeasure={true}
          />
        </Col>
        <Col xs={12} sm={4}>
          <StatTitle>{t("Last 24h")}</StatTitle>
          <SingleMeasure
            value={`${daily}`}
            units={units}
            alwaysBlackMeasure={true}
          />
        </Col>
      </Row>
      <Row>
        <Col xs={12} sm={4} />
        <Col>
          <RenderChartButton
            chartOpen={potentialChartOpen}
            flipState={flipPotentialGraphShow}
          />
        </Col>
      </Row>
      <GraphRow>
        <Col xs={12} sm={8}>
          <PotentialBreakdownGauge
            t={t}
            data={lossPercentages}
            opened={potentialChartOpen}
          />
        </Col>
      </GraphRow>
    </>
  );
}

export default withTranslation()(ExtraPotentialRowRevenue);
